import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { TextComponent } from 'baseComponents/TextComponent';
import { ButtonComponent } from 'baseComponents/ButtonComponent';

import { AuthPageWrapper } from 'components/layouts/AuthPageWrapper';
import { Flex, Spin, notification } from 'antd';
import { useResetUserPassword } from 'hooks/useResetUserPassword';
import * as Yup from 'yup';
import { TextInputComponent } from 'baseComponents/TextInputComponent';

type ForgotPasswordForm = {
  email: string;
};

export const forgotPasswordFormSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please provide correct email.')
    .required('Email is required.'),
});

export const ForgotPasswordScreen: React.FC = () => {
  const [api, contextHolder] = notification.useNotification();
  const { handleSubmit, control } = useForm<ForgotPasswordForm>({
    reValidateMode: 'onSubmit',
    resolver: yupResolver(forgotPasswordFormSchema),
  });

  const {
    mutate: resetPassword,
    isPending,
    error,
  } = useResetUserPassword({
    onSuccess: () => {
      return api.success({
        message: 'Reset password has been sent',
        description: 'Reset password link has been sent to your email.',
        duration: 3,
      });
    },
    onError: () => {
      return api.error({
        message: 'Something went wrong',
        description:
          error?.response?.data.message ||
          'Something went wrong with sending reset password link. Please try again later.',
        duration: 3,
      });
    },
  });

  const onSubmit = async ({ email }: ForgotPasswordForm) => {
    resetPassword(email);
  };

  return (
    <AuthPageWrapper
      title={<TextComponent size='title-size' text='Forgot password' inline />}
    >
      {contextHolder}
      <Spin spinning={isPending}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Flex vertical gap={20}>
            <Controller
              name='email'
              control={control}
              render={({ field, fieldState }) => (
                <TextInputComponent
                  label='Email'
                  error={fieldState.error?.message}
                  {...field}
                />
              )}
            />
            <span />
            <ButtonComponent
              appereance='primary'
              size='large'
              label='Send reset link'
              uppercase
              fullWidth
              htmlType='submit'
            />
          </Flex>
        </form>
      </Spin>
    </AuthPageWrapper>
  );
};
